import { generateToDocFn } from '@dadohr/shared/domainTypes/document';
import { isFeatureEnabled } from '@dadohr/shared/domainTypes/features';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import {
  USER_LEVEL_SCOPES_ACCOUNT_ADMIN,
  USER_ROLE
} from '@dadohr/shared/domainTypes/permissions';
import { SubscriptionProvider } from '@dadohr/shared/domainTypes/subscription';
import { difference } from 'lodash';
import { isFreeTierOrg } from '../organizationTier';

const INITIAL_ADMIN_SCOPES = [
  'experience.template.create',
  'experience.template.edit',
  'experience.template.view',
  'experience.template.launch',
  'org.adminUsers.view',
  'org.integrations.view',
  'org.mappings.view',
  'org.settings.view',
  'user.imports.view'
];

export const toOrgDoc = generateToDocFn<IOrganization>((d) => {
  d.logoUrl = d.logoUrl || '';
  d.logoInvertedUrl = d.logoInvertedUrl || '';
  if (typeof d.defaultExperienceStartHour !== 'number') {
    d.defaultExperienceStartHour = 9;
  }
  d.customUserFields = d.customUserFields || [];
  d.dateFormats = d.dateFormats || { MMDDYYYY: 'MM/DD/YYYY' };
  d.experienceTheming = d.experienceTheming || null;
  d.salutations = d.salutations || null;
  d.fallbackSalutations = d.fallbackSalutations || null;
  d.customHints = d.customHints || null;
  d.sso = d.sso || { enabled: false };
  d.tier = d.tier || 'STANDARD';

  const selfCheckoutEnabled = isFeatureEnabled(d.features, 'SELF_CHECKOUT_V1');
  const freeTier = isFreeTierOrg(d);
  d.termsOfServiceAndPrivacyPolicy =
    d.termsOfServiceAndPrivacyPolicy ||
    (selfCheckoutEnabled || freeTier
      ? null
      : {
          accepted: true,
          editedBy: '',
          editedAt: d.createdAt
        });
  d.subscription =
    d.subscription ||
    (selfCheckoutEnabled || freeTier
      ? null
      : { provider: SubscriptionProvider.CUSTOM, type: 'unlimited' });

  Object.values(d.permissions).forEach((p) => {
    p.v2 = p.v2 || {
      role: USER_ROLE.ACCOUNT_ADMIN,
      scopes: USER_LEVEL_SCOPES_ACCOUNT_ADMIN(),
      additionalExpTplScopes: {}
    };
  });

  Object.values(d.permissions).forEach((p) => {
    if (!p.v2.role) {
      p.v2.role =
        difference(INITIAL_ADMIN_SCOPES, p.v2.scopes).length === 0
          ? USER_ROLE.ACCOUNT_ADMIN
          : USER_ROLE.EXPERIENCE_MANAGER;
    }
  });
  return d;
});
